import React from "react";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


const completedTrip = () => {
  return (
    <div className="complete-trip">
      <Row>
        <Col>
          <div className="detail">
            <ul>
              <li className="id">ID:JPS6V36M</li>
              <li className="completed-trip"> COMPLETE</li>
              <li className="invoice">  INVOICE</li>
            </ul>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
        <div className="location">
        <LocationOnOutlinedIcon className="location-icon " />
        <p>
          Delhi-Aerocity-Metro-Station-Delhi-Aerocity-metro-station-Near-T1T3-IGI-Airport-New-Delhi
        </p>
      </div>
        </Col>
      </Row>

     
    </div>
  );
};

export default completedTrip;
